import { render, staticRenderFns } from "./NewFormWork.vue?vue&type=template&id=561f092e&scoped=true"
import script from "./NewFormWork.vue?vue&type=script&lang=js"
export * from "./NewFormWork.vue?vue&type=script&lang=js"
import style0 from "./NewFormWork.vue?vue&type=style&index=0&id=561f092e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f092e",
  null
  
)

export default component.exports